// extracted by mini-css-extract-plugin
export default {"resetButton":"resetButton---Pz93_"};